<template>
  <div class="form-plain">
    <form-plain-step
      v-for="(step, stepIndex) in steps"
      :id="`form-plain-step-${step.stepId}`"
      :ref="`step-${step.stepId}`"
      :key="`form-plain-step-${step.stepId}`"
      :index="stepIndex"
      :payload="payload"
      :step-id="step.stepId"
      :form-observer="formObserver"
      :title="step.stepLabel"
      :questions="step.questions"
      :is-available="stepIndex === 0 ? true : stepsPassed[steps[stepIndex - 1].stepId]"
      :is-next-step-available="(stepIndex === steps.length - 1) ? false : stepsPassed[steps[stepIndex].stepId]"
      :is-confirm-steps="isConfirmSteps"
      :is-edit-process="isEditProcess"
      :is-continue-triggered="isContinueTriggered"
      :session-data="sessionData"
      class="form-plain__step"
      :class="{ 'mt-6': stepIndex > 0 }"
      @data="$emit('data', $event)"
      @observer="$emit('observer', {
        observer: $event,
        stepId: step.stepId,
      })"
      @passed="$emit('passed', $event)"
      @show-confirm-form="$emit('show-confirm-form', $event)"
      @edit-process="$emit('edit-process', $event)"
      @reset-continue-trigger="$emit('reset-continue-trigger', $event)"
    />
  </div>
</template>

<script>
import FormPlainStep from '../FormPlainStep';

export default {
  name: 'form-plain',
  components: {
    FormPlainStep,
  },
  inject: ['formMetadata'],
  props: {
    sessionData: {
      type: Object,
      required: true,
    },
    payload: {
      type: Object,
      required: true,
    },
    formObserver: {
      type: Object,
      required: true,
    },
    stepsPassed: {
      type: Object,
      required: true,
    },
    isConfirmSteps: {
      type: Boolean,
      required: true,
    },
    isEditProcess: {
      type: Boolean,
      required: false,
    },
    isContinueTriggered: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    steps () {
      if (this.isConfirmSteps) {
        return this.formMetadata.confirmSteps;
      }

      return this.formMetadata.steps;
    },
  },
};
</script>
